<div class="badge-container" [class.badge-row]="direction === 'row'">
    @for (badge of badges; track $index) {
        <a
                class="badge-row-item"
                [class.badge-row-item--empty]="badge.amount === '0'"
                [routerLink]="badge.amount !== '0' ? badge.routerLink : null"
        >
      <span class="badge-row-item__left">
        @if (badge.icon) {
            <i class="pi badge-row-item__icon" [class]="badge.icon"></i>
        }
        <span class="badge-row-item__label">{{ badge.label | translate }}</span>
      </span>
            <span class="badge-row-item__right">
        <span class="badge-row-item__count">{{ badge.amount }}</span>
                @if (badge.amount !== '0') {
                    <i class="pi pi-chevron-right badge-row-item__chevron"></i>
                }
      </span>
        </a>
    }
</div>
